/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plus_Bonus_TagInputs */

const en_plus_bonus_tag = /** @type {(inputs: Plus_Bonus_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Bonus`)
};

const ar_plus_bonus_tag = /** @type {(inputs: Plus_Bonus_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مكافأة Plus`)
};

const de_plus_bonus_tag = /** @type {(inputs: Plus_Bonus_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus-Bonus`)
};

const es_plus_bonus_tag = /** @type {(inputs: Plus_Bonus_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonus Plus`)
};

const fr_plus_bonus_tag = /** @type {(inputs: Plus_Bonus_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonus Plus`)
};

const it_plus_bonus_tag = /** @type {(inputs: Plus_Bonus_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonus Plus`)
};

const ja_plus_bonus_tag = /** @type {(inputs: Plus_Bonus_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plusボーナス`)
};

const ko_plus_bonus_tag = /** @type {(inputs: Plus_Bonus_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 보너스`)
};

const pt_br_plus_bonus_tag = /** @type {(inputs: Plus_Bonus_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bônus Plus`)
};

const ru_plus_bonus_tag = /** @type {(inputs: Plus_Bonus_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бонус Plus`)
};

const th_plus_bonus_tag = /** @type {(inputs: Plus_Bonus_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โบนัส Plus`)
};

const tr_plus_bonus_tag = /** @type {(inputs: Plus_Bonus_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Bonusu`)
};

const zh_cn_plus_bonus_tag = /** @type {(inputs: Plus_Bonus_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 奖励`)
};

const zh_tw_plus_bonus_tag = /** @type {(inputs: Plus_Bonus_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 加碼`)
};

/**
* | output |
* | --- |
* | "Plus Bonus" |
*
* @param {Plus_Bonus_TagInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const plus_bonus_tag = /** @type {((inputs?: Plus_Bonus_TagInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plus_Bonus_TagInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plus_bonus_tag(inputs)
	if (locale === "ar") return ar_plus_bonus_tag(inputs)
	if (locale === "de") return de_plus_bonus_tag(inputs)
	if (locale === "es") return es_plus_bonus_tag(inputs)
	if (locale === "fr") return fr_plus_bonus_tag(inputs)
	if (locale === "it") return it_plus_bonus_tag(inputs)
	if (locale === "ja") return ja_plus_bonus_tag(inputs)
	if (locale === "ko") return ko_plus_bonus_tag(inputs)
	if (locale === "pt_br") return pt_br_plus_bonus_tag(inputs)
	if (locale === "ru") return ru_plus_bonus_tag(inputs)
	if (locale === "th") return th_plus_bonus_tag(inputs)
	if (locale === "tr") return tr_plus_bonus_tag(inputs)
	if (locale === "zh_cn") return zh_cn_plus_bonus_tag(inputs)
	return zh_tw_plus_bonus_tag(inputs)
});